import React, {useEffect, useState} from "react";
import {Col} from "reactstrap";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import Table from "../../components/Table/Table";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import {defterUnitNameShort} from "../../helper/permission";
import {EntegratorConf} from "../../constants";

const TopluKontorList = (props) => {
    const {currentUser} = props;
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [content, setContent] = useState([]);
    const [searching, setSearching] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState(null);

    const fetchData = (accessor, direction, page, size) => {
        let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '&sort=createdBy,desc';
        let search = searchQuery ? '&' + searchQuery : '';
        let params = {
            url: '/credit/getTopluKontorBayiList/?page=' + page + '&size=' + size + sortStr + search,
            method: "post"
        };
        setLoading(true);
        setSearching(true);
        request(params)
            .then((response) => {
                setPage(page);
                setTotal(response.data.totalElements);
                setContent(response.data.content);
                setSearching(false);
                setLoading(false);
            }).catch((err) => {
            setSearching(false);
            setLoading(false);
            showAxiosError(err);
        })
    }

    const handleSearch = (searchQueryNew) => {
        setSearching(true);
        setSearchQuery(searchQueryNew ?? null);
    }

    useEffect(() => {
        fetchData(undefined, null, 0, size);
    }, [searchQuery])

    const columns = [
        {
            accessor: [
                {Header: "VKN/TCKN", accessor: "vknTckn", sortable: false},
                {Header: "Ünvan", accessor: "formattedName", sortable: false}
            ],
            Cell: row => (<div style={{textAlign: "center"}}>
                {row.vknTckn}<br/>
                {<TextOverFlowTooltip text={row.formattedName} maxLength={20}/>}
            </div>)
        },
        {
            accessor: [
                {Header: "Kredi Türü", accessor: "unit", sortable: false}
            ],
            Cell: row => (
                <div style={{textAlign: "center"}}>
                    {row.unit === 1 ? "Kontör" : (row.unit === 2 ? defterUnitNameShort(EntegratorConf.identifier) : (row.unit === 3 ? "Arşiv Kasa" : ""))}
                </div>)
        },
        {
            accessor: [
                {Header: "Toplam Alınan Miktar", accessor: "purchaseQuantity", sortable: false},
                {Header: "Toplam Satılan Miktar", accessor: "sellQuantity", sortable: false}
            ],
            Cell: row => (
                <div style={{textAlign: "center"}}>
                    {row.purchaseQuantity}<br/>
                    {row.sellQuantity}
                </div>)
        },
        {
            accessor: [
                {Header: "Kalan Miktar", accessor: "totalCount", sortable: false}
            ],
            Cell: row => (
                <div style={{textAlign: "center"}}>
                    {row.purchaseQuantity - row.sellQuantity}
                </div>)
        }
    ];

    const fields = [
        {
            label: "VKN/TCKN",
            accessor: "vknTckn",
            type: "text",
            operator: "="
        },
        {
            label: "Ünvan",
            accessor: "formattedName",
            type: "text",
            operator: "="
        },
    ];

    return (
        <Col sm="12">
            <div className="card-body">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="" style={{marginTop: '10px', marginBottom: '10px'}} id="PayTrPrefixDetailedContainer">
                            <DetailedSearch fields={fields}
                                            loading={searching}
                                            onSearch={handleSearch} hasContainer="PayTrPrefixDetailedContainer"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className=" row">
                    <div className="col-sm-12" style={{float: 'right'}}>

                    </div>
                </div>
                <div className=" row">
                    <div className="col-sm-12">
                        <Table columns={columns}
                               loading={loading}
                               loadingText="Kayıtlar Getiriliyor..."
                               content={content}
                               total={total}
                               page={page}
                               size={size}
                               options={["5", "10", "20", "50", "100"]}
                               fetchData={fetchData}
                        />
                    </div>
                </div>
            </div>
        </Col>
    )
}

export default TopluKontorList;